// Keeps a local browser copy after real backend submissions succeed.
const KEY = "tmt_leads";
const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

const apiUrl = (path) => `${API_BASE}${path}`;

export const saveLead = (type, payload) => {
  try {
    const existing = JSON.parse(localStorage.getItem(KEY) || "[]");
    const record = { id: `lead_${Date.now()}`, type, submittedAt: new Date().toISOString(), ...payload };
    existing.push(record);
    localStorage.setItem(KEY, JSON.stringify(existing));
    return record;
  } catch (e) {
    return null;
  }
};

export const getLeads = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch (e) {
    return [];
  }
};

export const submitLead = async (type, payload) => {
  const response = await fetch(apiUrl("/api/leads"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ type, payload }),
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const record = await response.json();
  saveLead(type, { ...payload, serverId: record.id });
  return record;
};

export const getAvailability = async (refresh = 0) => {
  const query = refresh ? `?refresh=${encodeURIComponent(refresh)}` : "";
  const response = await fetch(apiUrl(`/api/availability${query}`));
  if (!response.ok) {
    throw new Error(await response.text());
  }
  return response.json();
};

export const submitBooking = async (payload) => {
  const response = await fetch(apiUrl("/api/bookings"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const record = await response.json();
  saveLead("consultation", { ...payload, serverId: record.id });
  return record;
};

export const submitAuditLead = async (payload, file) => {
  const body = new FormData();
  Object.entries(payload).forEach(([key, value]) => body.append(key, value || ""));
  body.append("invoice", file);

  const response = await fetch(apiUrl("/api/leads/billing-audit"), {
    method: "POST",
    body,
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const record = await response.json();
  saveLead("billing_audit", { ...payload, fileName: file.name, serverId: record.id });
  return record;
};

const PUBLIC_DOMAINS = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "icloud.com", "aol.com"];

export const isBusinessEmail = (email) => {
  if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) return false;
  const domain = email.split("@")[1]?.toLowerCase();
  return !PUBLIC_DOMAINS.includes(domain);
};
